/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const currency_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.75 3.75h-2.033a1.342 1.342 0 0 0-.5 2.587l2.064.826a1.342 1.342 0 0 1-.5 2.587H15.75m1.5-6V3m0 7.5v-.75m-9 10.5a3 3 0 0 1 0-6m-3.75 3h3.75M1 4.5l2.25 3.75m0 0L7 6M3.25 8.25l.522-.464A6.752 6.752 0 0 1 8.189.9M23 19.5l-2.25-3.75m0 0L17 18m3.75-2.25-.522.466a6.752 6.752 0 0 1-4.417 6.884M23.25 6.75a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-10.5 10.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
    />
  </svg>
)
export default currency_medium
